import { useMemo, useState } from 'react'
import { Card, Col, Input, Row, Statistic, Table, Tag, Typography } from 'antd'

const { Title } = Typography
import productCenter from '../data/productCenter.json'

const CategoryManager = () => {
  const [keyword, setKeyword] = useState('')

  const categories = useMemo(
    () => productCenter.categories
      .filter((c: any) => !keyword || c.name.toLowerCase().includes(keyword.toLowerCase()))
      .map((c: any) => ({ ...c, key: c.name })),
    [keyword]
  )

  const childPaths = useMemo(() => {
    const counts = new Map<string, number>()
    for (const p of productCenter.products) {
      const path = p.newCategory?.split('/').filter(Boolean)
      if (!path || path.length < 2) continue
      const key = path.slice(0, 2).join(' / ')
      counts.set(key, (counts.get(key) || 0) + 1)
    }
    return [...counts.entries()]
      .map(([path, count]) => ({ key: path, path, count }))
      .sort((a, b) => b.count - a.count)
  }, [])

  return (
    <div>
      <Row gutter={[16, 16]} className="mb-4">
        <Col xs={24} sm={8}><Card><Statistic title="一级分类" value={productCenter.stats.categoryCount} /></Card></Col>
        <Col xs={24} sm={8}><Card><Statistic title="二级分类路径" value={childPaths.length} /></Card></Col>
        <Col xs={24} sm={8}><Card><Statistic title="商品记录" value={productCenter.stats.total} /></Card></Col>
      </Row>

      <Card title="商品中心 · 分类管理">
        <Input allowClear placeholder="搜索一级分类" value={keyword} onChange={e => setKeyword(e.target.value)} style={{ maxWidth: 320, marginBottom: 16 }} />
        <Table
          columns={[
            { title: '分类', dataIndex: 'name', key: 'name', render: (v: string) => <Tag color="blue">{v}</Tag> },
            { title: '商品数', dataIndex: 'count', key: 'count', sorter: (a: any, b: any) => a.count - b.count },
            {
              title: '占比',
              key: 'percent',
              render: (_: any, record: any) => `${((record.count / productCenter.stats.total) * 100).toFixed(1)}%`,
            },
          ]}
          dataSource={categories}
          pagination={false}
        />
        <Table
          style={{ marginTop: 24 }}
          title={() => '二级分类分布'}
          columns={[
            { title: '分类路径', dataIndex: 'path', key: 'path' },
            { title: '商品数', dataIndex: 'count', key: 'count', sorter: (a: any, b: any) => a.count - b.count },
          ]}
          dataSource={childPaths}
          pagination={{ pageSize: 20, showSizeChanger: true }}
        />
      </Card>
    </div>
  )
}

export default CategoryManager

